<style lang="less">
    @import "../../../styles/table.less";
</style>
<template>
    <div class="search">
        <Row>
            <Col>
                <Card title="国开学籍审核">
                    <Row @keydown.enter.native="handleSearch">
                        <Form ref="searchForm" :model="searchForm" inline :label-width="70">
                            <Form-item label="学员名称" prop="userName">
                                <Input type="text" v-model="searchForm.userName" placeholder="请输入学员名称" clearable style="width: 200px"/>
                            </Form-item>
                            <Form-item label="身份证号" prop="userName">
                                <Input type="text" v-model="searchForm.idCard" placeholder="请输入身份证号" clearable style="width: 200px"/>
                            </Form-item>
                            <Form-item style="margin-left:-35px;" class="br">
                                <Button @click="handleSearch" type="primary" icon="ios-search">搜索</Button>
                                <Button @click="handleReset">重置</Button>
                                <a class="drop-down" @click="dropDown">{{dropDownContent}}
                                    <Icon :type="dropDownIcon"></Icon>
                                </a>
                            </Form-item>
                        </Form>
                    </Row>
                    <Row class="operation">
                        <Button @click="importFile" icon="md-add">导入学籍</Button>
                        <Button @click="download" icon="md-arrow-round-down">下载模板</Button>
                        <circleLoading v-if="operationLoading"/>
                    </Row>
                    <Row>
                        <Table :loading="loading" border :columns="columns"  size="small"  :data="data" sortable="custom" @on-sort-change="changeSort" @on-selection-change="showSelect" ref="table"></Table>
                    </Row>
                    <Row type="flex" justify="end" class="page">
                        <Page :current="searchForm.pageNumber" :total="total" :page-size="searchForm.pageSize" @on-change="changePage" @on-page-size-change="changePageSize" :page-size-opts="[10,20,50]" size="small" show-total show-elevator show-sizer></Page>
                    </Row>
                </Card>
            </Col>
        </Row>
        <Upload action="/base/common/importGkExcel" :on-success="handleSuccess"  v-show="false">
            <Button icon="ios-cloud-upload-outline" ref="upload">Upload files</Button>
        </Upload>
        <gkregister-drawer ref="gkregisterDrawer"></gkregister-drawer>
    </div>
</template>

<script>
    import circleLoading from "../../my-components/circle-loading.vue";
    import {userGkregisterList} from "@/api/bus";
    import gkregisterDrawer from "./gkregister-drawer";
    export default {
        name: "gkregister-manage",
        components: {
            gkregisterDrawer,
            circleLoading
        },
        data() {
            return {
                loading: false, // 表单加载状态
                operationLoading: false,
                drop: false,
                selectCount: 0, // 多选计数
                selectList: [], // 多选数据
                dropDownContent: "展开",
                dropDownIcon: "ios-arrow-down",
                searchForm: {
                    pageNumber: 1, // 当前页数
                    pageSize: 10, // 页面大小
                    sort: "", // 默认排序字段
                    order: "desc", // 默认排序方式
                    userName: "",
                    idCard: "",
                    registerStatus: 100
                },
                selectDate: null, //选择日期绑定modal
                columns: [

                    {
                        type: "index",
                        width: 50,
                        fixed: "left",
                        align: "center"
                    },
                    {
                        title: "学员名称",
                        width: 100,
                        align: "center",
                        fixed: "left",
                        render: (h, params) => {
                            let re = "";
                            if (params.row.userName) {
                                re = params.row.userName;
                            } else {
                                re = "未认定";
                            }
                            return h("div", re);
                        }
                    },
                    {
                        title: "昵称",
                        width: 100,
                        align: "center",
                        key: "nickName"
                    },
                    {
                        title: "身份证号",
                        width: 200,
                        align: "center",
                        key: "idCard"
                    },
                    {
                        title: "性别",
                        align: "center",
                        width: 100,
                        render: (h, params) => {
                            let re = "";
                            if (params.row.sex === 2) {
                                re = "男";
                            } else if (params.row.sex === 1) {
                                re = "女";
                            }
                            return h("div", re);
                        }
                    },
                    {
                        title: "手机号",
                        width: 150,
                        align: "center",
                        key: "mobile"
                    },
                    {
                        title: "国开学籍号",
                        width: 250,
                        align: "center",
                        key: "schoolNum"
                    },
                    {
                        title: "审核状态",
                        align: "center",
                        width: 100,
                        key: "schoolRegister",
                        render: (h, params) => {
                            if(params.row.schoolRegister === '1'){
                                return h("div", [
                                    h(
                                        "Tag",
                                        {
                                            props: {
                                                color: "blue"
                                            }
                                        },
                                        "待审核"
                                    )
                                ]);
                            } else if(params.row.schoolRegister === '2'){
                                return h("div", [
                                    h(
                                        "Tag",
                                        {
                                            props: {
                                                color: "green"
                                            }
                                        },
                                        "通过"
                                    )
                                ]);
                            } else if(params.row.schoolRegister === '3'){
                                return h("div", [
                                    h(
                                        "Tag",
                                        {
                                            props: {
                                                color: "red"
                                            }
                                        },
                                        "拒绝"
                                    )
                                ]);
                            } else {
                                return h("div", "--");
                            }

                        }
                    },
                    {
                        title: "生日",
                        width: 200,
                        align: "center",
                        key: "birthday"
                    },
                    {
                        title: "民族",
                        width: 100,
                        align: "center",
                        key: "nation"
                    },
                    {
                        title: "国籍",
                        width: 100,
                        align: "center",
                        key: "nationality"
                    },
                    {
                        title: "联系地址",
                        width: 350,
                        align: "center",
                        key: "address"
                    },
                    {
                        title: "邮箱",
                        width: 200,
                        align: "center",
                        key: "email"
                    },
                    {
                        title: "操作",
                        key: "action",
                        width: 100,
                        align: "center",
                        fixed: "right",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "primary",
                                            size: "small"
                                        },
                                        on: {
                                            click: () => {
                                                this.edit(params.row);
                                            }
                                        }
                                    },
                                    "审核"
                                )
                            ]);
                        }
                    }],
                data: [], // 表单数据
                total: 0 // 表单数据总数
            }
        },
        methods: {
            init() {
                this.getDataList();
            },
            getDataList() {
                this.loading = true;
                console.info(JSON.stringify(this.searchForm))
                userGkregisterList(this.searchForm).then(res => {
                    this.loading = false;
                    if (res.status === true) {
                        this.data = res.data.rows;
                        this.total = res.data.total;
                    }
                });
            },
            edit(v) {
                this.$refs.gkregisterDrawer.showDrawer(v);
            },
            download() {
                location.href = "../国开学籍.xlsx";
            },
            importFile() {
                this.$refs.upload.$el.click()
            },
            handleSuccess(response, file, fileList) {
                if(response.status){
                    this.$Message.success(response.info);
                    this.getDataList();
                }else{
                    this.$Message.error(response.info);
                }
            },
            //设置课程推荐状态
            handleSearch() {
                this.searchForm.pageNumber = 1;
                this.searchForm.pageSize = 10;
                this.getDataList();
            },
            handleReset() {
                this.$refs.searchForm.resetFields();
                this.searchForm.pageNumber = 1;
                this.searchForm.pageSize = 10;
                this.selectDate = null;
                this.searchForm.userName = "";
                this.searchForm.idCard = "";
                this.searchForm.registerStatus = 100;
                // 重新加载数据
                this.getDataList();
            },
            dropDown() {
                if (this.drop) {
                    this.dropDownContent = "展开";
                    this.dropDownIcon = "ios-arrow-down";
                } else {
                    this.dropDownContent = "收起";
                    this.dropDownIcon = "ios-arrow-up";
                }
                this.drop = !this.drop;
            },
            changePage(v) {
                this.searchForm.pageNumber = v;
                this.getDataList();
                this.clearSelectAll();
            },
            changePageSize(v) {
                this.searchForm.pageSize = v;
                this.getDataList();
            },
            changeSort(e) {
                this.searchForm.sort = e.key;
                this.searchForm.order = e.order;
                if (e.order === "normal") {
                    this.searchForm.order = "";
                }
                this.getDataList();
            },
            showSelect(e) {
                this.selectList = e;
                this.selectCount = e.length;
            },
            clearSelectAll() {
                this.$refs.table.selectAll(false);
            },
        },
        mounted() {
            this.init();
        }
    }
</script>
